import Decimal from 'decimal.js';
import { DiscountModel, DiscountType, serviceBillingModel, serviceModel } from '~/models';
import { utils } from '~/utils';
export const applyDiscount = function applyDiscount(price) {
    let discount = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Decimal(0), discountType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : DiscountType.Value;
    const discountedPrice = utils.applyDiscount(price, DiscountModel.make(discountType, discount));
    return utils.formatDollarAmount(discountedPrice);
};
export function applyChangesToService(s) {
    if (!serviceModel.isAmended(s.status)) {
        return s;
    }
    const newService = serviceModel.applyChanges(s);
    const billing = s.billing;
    return serviceBillingModel.isOngoing(billing) ? serviceModel.setPaused(newService, billing.isPaused) : newService;
}
export function getPauseDisabledTooltip(isCredit) {
    const type = isCredit ? 'Credit' : 'Automatic service';
    return "".concat(type, " status changes take effect immediately, and are therefore only available when managing the upcoming invoice");
}
export const nonBillableReasonToTooltip = {
    issuingInvoice: 'An invoice is being issued. Please wait',
    billedMaxCharges: 'This service was already billed the maximum number of times'
};
